export const isNullish = (value: unknown) => {
  return value === null || value === undefined;
};

export default null; // silence a false warning
